import { render, staticRenderFns } from "./AppSettingsSelectionCriteria.vue?vue&type=template&id=c49e676c&scoped=true&"
import script from "./AppSettingsSelectionCriteria.vue?vue&type=script&lang=js&"
export * from "./AppSettingsSelectionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsSelectionCriteria.vue?vue&type=style&index=0&id=c49e676c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49e676c",
  null
  
)

export default component.exports